import { NAME as namespace } from './constants';
import { abstractReducer as reducer } from './reducer';
export var abstract = {
  namespace: namespace,
  reducer: reducer
};
export default abstract;